import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import Triangles from './components/Triangles';
import Poll from './components/Poll';

function App() {
    const user = {
        id: '12313',
        name: 'Rick Sanchez',
        image: 'https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp',
    };

    const [polls, setPolls] = useState([]);
    const [visibleGroups, setVisibleGroups] = useState(2);

    const pollDates = Object.keys(polls);

    useEffect(() => {
        axios
            .get('/polls.json')
            .then((response) => {
                const pollsData = response.data;
                const groupedPolls = pollsData.reduce((acc, poll) => {
                    const date = poll.created_at.split('T')[0]; // Get the date part
                    if (!acc[date]) {
                        acc[date] = [];
                    }
                    acc[date].push(poll);
                    return acc;
                }, {});

                setPolls(groupedPolls);
            })
            .catch((error) => {
                console.error('Error fetching polls:', error);
            });
    }, []);

    const handleVote = (pollId, optionId) => {
        setPolls((prevPolls) =>
            Object.keys(prevPolls).reduce((acc, date) => {
                acc[date] = prevPolls[date].map((poll) => {
                    if (poll.id === pollId) {
                        return {
                            ...poll,
                            showResults: true,
                            options: poll.options.map((option) => {
                                if (option.id === optionId) {
                                    let hasVoted = option.votes.some(
                                        (vote) => vote.id === user.id
                                    );

                                    if (!hasVoted) {
                                        return {
                                            ...option,
                                            votes: [
                                                {
                                                    id: user.id,
                                                    name: user.name,
                                                    image: user.image,
                                                },
                                                ...option.votes,
                                            ],
                                            voted: true,
                                        };
                                        // axios
                                        //     .post(window.url.submitVote)
                                        //     .then((response) => {
                                        //         return {
                                        //             ...option,
                                        //             votes: [
                                        //                 ...option.votes,
                                        //                 {
                                        //                     id: user.id,
                                        //                     name: user.name,
                                        //                     image: user.image,
                                        //                 },
                                        //             ],
                                        //             voted: true,
                                        //         };
                                        //     })
                                        //     .catch((error) => {
                                        //         console.error(
                                        //             'Error submiting vote:',
                                        //             error
                                        //         );
                                        //     });
                                    }
                                } else {
                                    return {
                                        ...option,
                                        votes: option.votes.filter(
                                            (voter) => voter.id !== user.id
                                        ),
                                        voted: false,
                                    };
                                }
                                return option;
                            }),
                        };
                    }
                    return poll;
                });
                return acc;
            }, {})
        );

        console.log(window.url.submitVote);
    };

    const handleShowMore = () => {
        setVisibleGroups((prevVisibleGroups) => prevVisibleGroups + 2);
    };

    return (
        <div className='p-10 w-full text-[#333] flex flex-col justify-center'>
            <h1 className='text-center text-4xl'>Find your Tribe</h1>
            <div className='my-5'>
                <Triangles />
            </div>
            <div className='flex flex-col gap-[50px]'>
                {pollDates.length > 0 &&
                    pollDates.slice(0, visibleGroups).map((date, index) => (
                        <div key={date}>
                            <h2 className='text-center text-2xl mb-[20px]'>
                                {new Date(date).toLocaleDateString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                })}
                            </h2>
                            <div className='flex flex-col lg:flex-row justify-center items-center lg:items-stretch gap-10'>
                                {polls[date].map((poll) => (
                                    <Poll
                                        key={poll.id}
                                        user={user}
                                        poll={poll}
                                        setPolls={setPolls}
                                        handleVote={handleVote}
                                    />
                                ))}
                            </div>
                            {index !==
                            pollDates.slice(0, visibleGroups).length - 1 ? (
                                <div className='divider m-0 mt-[50px]'>
                                    <Triangles />
                                </div>
                            ) : null}
                        </div>
                    ))}

                {visibleGroups < pollDates.length && (
                    <div className='flex justify-center'>
                        <button
                            className='btn btn-primary bg-[#73b525] hover:bg-[#73b525]/80 text-white rounded-md'
                            onClick={handleShowMore}>
                            Show More
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default App;
